import $ from 'jquery';

export const init = () => {
	$('.inp-switch__wrapper').on('click', function (e) {
		const $this = $(this),
			calc = $('.calc-result').length;
		if (calc < 1) {
			e.preventDefault();
			//checkbox toggling on left & right label click
			const $checkbox = $(this).find('input[type=checkbox]');
			$checkbox.prop('checked', !$checkbox.prop('checked'));
		}

		$this.toggleClass('inp-switch__wrapper--on');
	});

	/** On keyboard spacebar keydown */
	$('.inp-switch__wrapper').on('keydown', function (e) {
		if ($(document.activeElement)) {
			if (e.code === 'Space' || e.which === 32) {
				e.preventDefault();
				const $checkbox = $(this).find('input[type="checkbox"]');

				$checkbox.prop('checked', !$checkbox.prop('checked'));

				$(this).toggleClass('inp-switch__wrapper--on');
			}
		}
	});
};
